import DateTimePicker from '@react-native-community/datetimepicker';
import moment from 'moment';
import React, {useState} from 'react';
import {
  ActivityIndicator,
  ScrollView,
  Text,
  TouchableOpacity,
  View,
  StyleSheet,
} from 'react-native';
import {Card} from 'react-native-paper';
import FontAwesome from '@react-native-vector-icons/fontawesome';
import {useSelector} from 'react-redux';
import {useGetFOEReservationByDateQuery} from '../redux/services/foereservationApi';
import {useGetFORoomssQuery} from '../redux/services/foroomsApi';
import {RootState} from '../redux/store';
import {theme} from '../theme/theme';

import T from '../Components/T';
const styles = StyleSheet.create({
  container: {
    flex: 1,
    backgroundColor: theme.colors.backgroundSecondary,
  },
  loaderContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    backgroundColor: theme.colors.backgroundSecondary,
  },
  loadingText: {
    marginTop: theme.spacing.base,
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.textSecondary,
    fontWeight: theme.typography.fontWeight.medium,
  },
  header: {
    backgroundColor: theme.colors.primary,
    paddingTop: theme.spacing['2xl'],
    paddingBottom: theme.spacing.xl,
    paddingHorizontal: theme.spacing.xl,
    ...theme.shadows.md,
  },
  headerContent: {
    flexDirection: 'row',
    alignItems: 'center',
  },
  headerIconContainer: {
    width: 56,
    height: 56,
    borderRadius: theme.borderRadius.full,
    backgroundColor: 'rgba(255, 255, 255, 0.2)',
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing.base,
  },
  headerTextContainer: {
    flex: 1,
  },
  headerTitle: {
    fontSize: theme.typography.fontSize['2xl'],
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.white,
    marginBottom: theme.spacing.xs,
  },
  headerSubtitle: {
    fontSize: theme.typography.fontSize.sm,
    color: 'rgba(255, 255, 255, 0.9)',
    fontWeight: theme.typography.fontWeight.regular,
  },
  dateContainer: {
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'space-between',
    margin: theme.spacing.base,
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.xl,
    padding: theme.spacing.xs,
    ...theme.shadows.sm,
  },
  dateNavButton: {
    width: 44,
    height: 44,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.colors.backgroundSecondary,
    justifyContent: 'center',
    alignItems: 'center',
  },
  dateButton: {
    flex: 1,
    flexDirection: 'row',
    alignItems: 'center',
    justifyContent: 'center',
    paddingVertical: theme.spacing.base,
    paddingHorizontal: theme.spacing.base,
  },
  dateIcon: {
    marginRight: theme.spacing.xs,
  },
  dateText: {
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.textPrimary,
    marginRight: theme.spacing.xs,
  },
  dateRangeText: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.textTertiary,
    fontWeight: theme.typography.fontWeight.regular,
  },
  scrollView: {
    flex: 1,
  },
  scrollContent: {
    padding: theme.spacing.base,
    paddingBottom: 80,
  },
  roomTypeContainer: {
    marginBottom: theme.spacing.base,
  },
  roomTypeCard: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.xl,
    overflow: 'hidden',
    ...theme.shadows.md,
  },
  roomTypeHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: theme.spacing.base,
    backgroundColor: theme.colors.backgroundSecondary,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderLight,
  },
  roomTypeHeaderLeft: {
    flexDirection: 'row',
    alignItems: 'center',
    flex: 1,
  },
  roomTypeIconContainer: {
    width: 40,
    height: 40,
    borderRadius: theme.borderRadius.md,
    backgroundColor: theme.colors.white,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing.base,
  },
  roomTypeInfo: {
    flex: 1,
  },
  roomTypeName: {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.textPrimary,
    marginBottom: theme.spacing.xs / 2,
  },
  roomTypeCount: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.textTertiary,
    fontWeight: theme.typography.fontWeight.regular,
  },
  expandIcon: {
    padding: theme.spacing.xs,
  },
  availabilityGrid: {
    flexDirection: 'row',
    flexWrap: 'wrap',
    padding: theme.spacing.base,
  },
  availabilityCell: {
    width: '20%',
    alignItems: 'center',
    paddingVertical: theme.spacing.base,
    paddingHorizontal: theme.spacing.xs,
    marginBottom: theme.spacing.base,
  },
  todayCell: {
    backgroundColor: theme.colors.infoLight,
    borderRadius: theme.borderRadius.md,
    borderWidth: 1,
    borderColor: theme.colors.info,
  },
  availabilityDate: {
    fontSize: theme.typography.fontSize.sm,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.textPrimary,
    marginBottom: theme.spacing.xs / 2,
  },
  availabilityDay: {
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.textTertiary,
    marginBottom: theme.spacing.xs,
    textTransform: 'uppercase',
  },
  availabilityBadge: {
    width: 48,
    height: 48,
    borderRadius: theme.borderRadius.full,
    justifyContent: 'center',
    alignItems: 'center',
    marginBottom: theme.spacing.xs,
  },
  highAvailability: {
    backgroundColor: theme.colors.successLight,
  },
  mediumAvailability: {
    backgroundColor: theme.colors.warningLight,
  },
  lowAvailability: {
    backgroundColor: theme.colors.errorLight,
  },
  availabilityCount: {
    fontSize: theme.typography.fontSize.lg,
    fontWeight: theme.typography.fontWeight.bold,
    color: theme.colors.textPrimary,
  },
  availabilityLabel: {
    fontSize: theme.typography.fontSize.xs,
    color: theme.colors.textTertiary,
    fontWeight: theme.typography.fontWeight.medium,
  },
  expandedContainer: {
    backgroundColor: theme.colors.white,
    borderRadius: theme.borderRadius.xl,
    marginTop: theme.spacing.xs,
    padding: theme.spacing.base,
    ...theme.shadows.sm,
  },
  expandedHeader: {
    flexDirection: 'row',
    justifyContent: 'space-between',
    alignItems: 'center',
    marginBottom: theme.spacing.base,
    paddingBottom: theme.spacing.base,
    borderBottomWidth: 1,
    borderBottomColor: theme.colors.borderLight,
  },
  expandedTitle: {
    fontSize: theme.typography.fontSize.base,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.textPrimary,
  },
  expandedSubtitle: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.textTertiary,
  },
  roomList: {
    flexDirection: 'row',
    flexWrap: 'wrap',
  },
  roomItem: {
    flexDirection: 'row',
    alignItems: 'center',
    width: '33.33%',
    paddingVertical: theme.spacing.xs,
    paddingHorizontal: theme.spacing.xs,
  },
  roomItemIcon: {
    width: 24,
    height: 24,
    borderRadius: theme.borderRadius.sm,
    backgroundColor: theme.colors.backgroundSecondary,
    justifyContent: 'center',
    alignItems: 'center',
    marginRight: theme.spacing.xs,
  },
  roomItemName: {
    fontSize: theme.typography.fontSize.sm,
    color: theme.colors.textPrimary,
    fontWeight: theme.typography.fontWeight.medium,
  },
  emptyContainer: {
    flex: 1,
    justifyContent: 'center',
    alignItems: 'center',
    padding: theme.spacing['2xl'],
    minHeight: 400,
  },
  emptyText: {
    fontSize: theme.typography.fontSize.xl,
    fontWeight: theme.typography.fontWeight.semibold,
    color: theme.colors.textSecondary,
    marginTop: theme.spacing.base,
    marginBottom: theme.spacing.xs,
  },
  emptySubtext: {
    fontSize: theme.typography.fontSize.base,
    color: theme.colors.textTertiary,
    textAlign: 'center',
  },
});

const RoomAvailability = () => {
  const gdata = useSelector((state: RootState) => state.gdata);
  const cid = gdata.company;
  const [sdate, setSdate] = useState<Date>(new Date());
  const [showDatePicker, setShowDatePicker] = useState(false);
  const [expandedRoomType, setExpandedRoomType] = useState<string | null>(null);

  const {data: rooms, isLoading} = useGetFORoomssQuery(cid);
  const {data: reservations, isLoading: isLoading1} =
    useGetFOEReservationByDateQuery({
      cid: cid,
      fdt: moment(sdate).format('YYYY-MM-DD'),
      tdt: moment(sdate).add(9, 'days').format('YYYY-MM-DD'),
    });

  const getTotalRoomCountByType = (roomTypeId: number): number => {
    return rooms?.filter(room => room.rt_id === roomTypeId).length || 0;
  };

  const getRoomCountByTypePerDate = (roomTypeId: number): number[] => {
    const counts: number[] = [];
    for (let i = 0; i < 10; i++) {
      const date = moment(sdate).add(i, 'days').format('YYYY-MM-DD');
      const availableRooms = rooms?.filter(room => room.rt_id === roomTypeId);
      const reservedRooms = reservations?.filter(
        (reservation: any) =>
          availableRooms?.some(room => room.rm_name === reservation.rs_room) &&
          moment(reservation.rs_arrival).format('YYYY-MM-DD') <= date &&
          moment(reservation.rs_depature).format('YYYY-MM-DD') > date,
      );

      counts.push((availableRooms?.length || 0) - (reservedRooms?.length || 0));
    }
    return counts;
  };

  if (isLoading || isLoading1) {
    return (
      <View style={styles.loaderContainer}>
        <ActivityIndicator size="large" color={theme.colors.primary} />
        <Text style={styles.loadingText}><T>Loading availability...</T></Text>
      </View>
    );
  }

  const uniqueRoomTypes = rooms ? [...new Set(rooms.map(v => v.rt_name))] : [];

  return (
    <View style={styles.container}>
      {/* Header */}
      <View style={styles.header}>
        <View style={styles.headerContent}>
          <View style={styles.headerIconContainer}>
            <FontAwesome
              name="calendar-check-o"
              size={28}
              color={theme.colors.white}
            />
          </View>
          <View style={styles.headerTextContainer}>
            <Text style={styles.headerTitle}><T>Room Availability</T></Text>
            <Text style={styles.headerSubtitle}>
              {uniqueRoomTypes.length} <T>room types • 10-day view</T>
            </Text>
          </View>
        </View>
      </View>

      {/* Date Picker */}
      <View style={styles.dateContainer}>
        <TouchableOpacity
          style={styles.dateNavButton}
          onPress={() => setSdate(moment(sdate).subtract(10, 'days').toDate())}>
          <FontAwesome
            name="chevron-left"
            size={20}
            color={theme.colors.primary}
          />
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.dateButton}
          onPress={() => setShowDatePicker(true)}>
          <FontAwesome
            name="calendar"
            size={18}
            color={theme.colors.primary}
            style={styles.dateIcon}
          />
          <Text style={styles.dateText}>
            {moment(sdate).format('DD MMM YYYY')}
          </Text>
          <Text style={styles.dateRangeText}>
            <T>to</T> {moment(sdate).add(9, 'days').format('DD MMM')}
          </Text>
        </TouchableOpacity>
        <TouchableOpacity
          style={styles.dateNavButton}
          onPress={() => setSdate(moment(sdate).add(10, 'days').toDate())}>
          <FontAwesome
            name="chevron-right"
            size={20}
            color={theme.colors.primary}
          />
        </TouchableOpacity>
      </View>

      {showDatePicker && (
        <DateTimePicker
          value={sdate}
          mode="date"
          display="default"
          onChange={(event, selectedDate) => {
            setShowDatePicker(false);
            if (selectedDate) setSdate(selectedDate);
          }}
        />
      )}

      <ScrollView
        style={styles.scrollView}
        contentContainerStyle={styles.scrollContent}
        showsVerticalScrollIndicator={false}>
        {uniqueRoomTypes.length === 0 ? (
          <View style={styles.emptyContainer}>
            <FontAwesome
              name="building-o"
              size={64}
              color={theme.colors.mediumGray}
            />
            <Text style={styles.emptyText}><T>No room types available</T></Text>
            <Text style={styles.emptySubtext}>
              <T>Please configure room types in settings</T>
            </Text>
          </View>
        ) : (
          uniqueRoomTypes.map((roomType, index) => {
            const roomTypeData = rooms?.filter(v => v.rt_name === roomType) || [];
            const totalRooms = getTotalRoomCountByType(roomTypeData[0]?.rt_id);
            const vacantRoomsPerDate = getRoomCountByTypePerDate(
              roomTypeData[0]?.rt_id,
            );
            const isExpanded = expandedRoomType === roomType;

            return (
              <View key={index} style={styles.roomTypeContainer}>
                {/* Room Type Card */}
                <TouchableOpacity
                  activeOpacity={0.7}
                  onPress={() =>
                    setExpandedRoomType(isExpanded ? null : roomType)
                  }>
                  <Card style={styles.roomTypeCard} elevation={2}>
                    <View style={styles.roomTypeHeader}>
                      <View style={styles.roomTypeHeaderLeft}>
                        <View style={styles.roomTypeIconContainer}>
                          <FontAwesome
                            name="building"
                            size={20}
                            color={theme.colors.primary}
                          />
                        </View>
                        <View style={styles.roomTypeInfo}>
                          <Text style={styles.roomTypeName}>{roomType}</Text>
                          <Text style={styles.roomTypeCount}>
                            {totalRooms} {totalRooms === 1 ? 'room' : 'rooms'}
                          </Text>
                        </View>
                      </View>
                      <View style={styles.expandIcon}>
                        <FontAwesome
                          name={isExpanded ? 'chevron-up' : 'chevron-down'}
                          size={18}
                          color={theme.colors.textTertiary}
                        />
                      </View>
                    </View>

                    <View style={styles.availabilityGrid}>
                      {vacantRoomsPerDate.map((vacant, i) => {
                        const date = moment(sdate).add(i, 'days');
                        const isToday = date.isSame(moment(), 'day');
                        const availabilityPercent =
                          totalRooms > 0 ? (vacant / totalRooms) * 100 : 0;
                        const isLowAvailability = availabilityPercent < 30;
                        const isMediumAvailability =
                          availabilityPercent >= 30 && availabilityPercent < 70;

                        return (
                          <View
                            key={i}
                            style={[
                              styles.availabilityCell,
                              isToday && styles.todayCell,
                            ]}>
                            <Text style={styles.availabilityDate}>
                              {date.format('DD')}
                            </Text>
                            <Text style={styles.availabilityDay}>
                              {date.format('ddd')}
                            </Text>
                            <View
                              style={[
                                styles.availabilityBadge,
                                isLowAvailability && styles.lowAvailability,
                                isMediumAvailability && styles.mediumAvailability,
                                !isLowAvailability &&
                                  !isMediumAvailability &&
                                  styles.highAvailability,
                              ]}>
                              <Text style={styles.availabilityCount}>
                                {vacant}
                              </Text>
                            </View>
                            <Text style={styles.availabilityLabel}><T>Vacant</T></Text>
                          </View>
                        );
                      })}
                    </View>
                  </Card>
                </TouchableOpacity>

                {/* Expanded Room List */}
                {isExpanded && (
                  <View style={styles.expandedContainer}>
                    <View style={styles.expandedHeader}>
                      <Text style={styles.expandedTitle}><T>Room Details</T></Text>
                      <Text style={styles.expandedSubtitle}>
                        {roomTypeData.length} <T>rooms</T>
                      </Text>
                    </View>
                    <View style={styles.roomList}>
                      {roomTypeData.map((room, roomIndex) => (
                        <View key={room.rm_id} style={styles.roomItem}>
                          <View style={styles.roomItemIcon}>
                            <FontAwesome
                              name="bed"
                              size={16}
                              color={theme.colors.primary}
                            />
                          </View>
                          <Text style={styles.roomItemName}>
                            {room.rm_name}
                          </Text>
                        </View>
                      ))}
                    </View>
                  </View>
                )}
              </View>
            );
          })
        )}
      </ScrollView>
    </View>
  );
};

export default RoomAvailability;

